export default {
  NETWORK_ERROR: 'Network Error',
  CRITICAL_ERROR: 'Critical Error',
  SAVING_ERROR: 'Saving Error',
  READ_ONLY_ERROR: 'Read only Error',
};
